import { mapGetters } from 'vuex';
import _ from 'lodash';
import { planTypes } from '@/common/constants';

// softBundle4Pbx instance
export const softBundle4Pbx = {
  cycleInstance: null,
};

export default {
  computed: {
    ...mapGetters(['softBundleConfiguration']),
    /**
     * @description get zoom phone soft bundle configuration
     * @returns {SoftBundlePlanConfigBean}
     */
    softBundlePbxConfig() {
      return this.softBundleConfiguration?.[planTypes.ZOOM_PHONE];
    },
    depOnBasePlanListSwitchCycle() {
      return _.chain(this.softBundleConfiguration ?? {})
        .keys()
        .filter((planType) => {
          if (planType !== planTypes.ZOOM_PHONE) {
            const switchPlanTypeList = _.get(this.softBundleConfiguration,
              [planType, 'billingCycleSwitch', 'switchPlanTypeList'], []);

            return _.includes(switchPlanTypeList, planTypes.ZOOM_PHONE);
          }

          return false;
        })
        .value();
    },
    soft_bundle_hiddenCycleSelection() {
      return this.softBundlePbxConfig?.hiddenCycleSelection;
    },
    soft_bundle_hiddenOtherRegion() {
      return this.softBundlePbxConfig?.hiddenOtherRegion;
    },
    soft_bundle_hiddenTypeSwitch() { // uc | mc switch
      return this.softBundlePbxConfig?.hiddenTypeSwitch;
    },
    soft_bundle_hiddenAppealByoc() {
      return this.softBundlePbxConfig?.hiddenRemove;
    },
    soft_bundle_hiddenPlanCardRemove() {
      return this.softBundlePbxConfig?.hiddenRemove;
    },
  },
  methods: {
    filterRegions(regions = [], activeRegionKey) {
      if (!this.soft_bundle_hiddenOtherRegion) return regions;
      return _.filter(regions, (region) => region?.key === activeRegionKey);
    },
    setPbxCardInstance() {
      if (this.depOnBasePlanListSwitchCycle?.length) {
        softBundle4Pbx.cycleInstance = this.$refs?.pbxCardRef;
      }
    },
  },
};
